import AxiosHelper from '@shared/infra/protocols/http/AxiosHelper';

class ManageToken {
  static set(token: string): void {
    AxiosHelper.setToken(token);
  }

  static clear(): void {
    AxiosHelper.clearToken();
  }
}

export default ManageToken;
